export default "__VITE_ASSET__DnMORqrx__"